export const PERMS = {
    READ: 'report_spedition_transports.read',
    UPDATE: 'report_spedition_transports.update',
    DELETE: 'report_spedition_transports.delete',
    CREATE: 'report_spedition_transports.create',
    EXPORT: 'report_spedition_transports.export',
}
